export const PUSHER_CHANNEL_TYPES = {
  private: 'private',
} as const;

export type PusherChannelType = (typeof PUSHER_CHANNEL_TYPES)[keyof typeof PUSHER_CHANNEL_TYPES];

const PUSHER_CHANNEL_TYPE_PREFIXES: Record<PusherChannelType, string> = {
  [PUSHER_CHANNEL_TYPES.private]: 'private-',
};

// only private channel type this integration supports today , to add presence/public channels
// later, add a new PUSHER_CHANNEL_TYPES entry plus its prefix above
export const ACTIVE_PUSHER_CHANNEL_TYPE: PusherChannelType = PUSHER_CHANNEL_TYPES.private;

export const PUSHER_CHANNEL_PREFIX = PUSHER_CHANNEL_TYPE_PREFIXES[ACTIVE_PUSHER_CHANNEL_TYPE];
